import Icon from './Icon.vue'

export default Icon



// WEBPACK FOOTER //
// ./components/Icon/index.js